import React, {useEffect, useState} from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {ItemListadoServiciosTransporte, listarServiciosTransporte} from "../../../services/transporteServicios";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/transporte",
        label: "Transporte"
    },
    {
        path: "/servicios/transporte",
        label: "Transporte",
        isActive: true
    }
]

function ListaServiciosTransporte(){
    const [items, setItems] = useState([] as ItemListadoServiciosTransporte[]);

    useEffect(() => {
        async function poblarItems() {
            const resp = await listarServiciosTransporte();
            if(resp){
                setItems(resp);
            }
        }

        poblarItems();
    }, []);

    return (
        <Page description="Visualiza, edita y crea servicios de transporte." title="Reservas de Transporte" breadCrumbs={breadCrumbs}>
            <TableSection items={items} />
        </Page>
    );
}

export default ListaServiciosTransporte;